import React, { Fragment, useState, useMemo } from "react"
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table"
import { Table } from "reactstrap"
import { DefaultColumnFilter } from "../../Components/filters"
import TableBody from "./TableBody"
import TableFooter from "./TableFooter"
import TableHead from "./TableHead"

const TableContainer = ({
  columns,
  data,
  onHeaderClick,
  customPageSize,
  totalCount,
  pageindex,
  widthControl,
  isMobile,
  footeraddition,
  activeworkfromhome,
  tableheadShow,
  tableHeader,
  dateMatch,
  onClick,
  setExpandedRow,
  expandedRow,
}) => {
  const hiddenColumns = useMemo(() => {
    const hidden = []
    columns.forEach(el => {
      if (el?.hidden === true) {
        hidden.push(el.accessor)
      }
    })
    return hidden
  }, [columns])

  const pageCount = useMemo(
    () => Math.ceil(totalCount / customPageSize),
    [totalCount, customPageSize]
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    footerGroups,
  } = useTable(
    {
      columns,
      data,
      onHeaderClick: Function,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: pageindex,
        pageSize: customPageSize,
        hiddenColumns: hiddenColumns,
      },
      manualPagination: true,
      manualSortBy: false,
      pageCount: pageCount,
      disableSortRemove: true
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )

  const [totalHoursLoader, SettotalHoursLoader] = useState(false)

  const generateSortingIndicator = column => {
    return (
      column.sort && (
        <i
          className={column.isSortedDesc ? "bx bx-sort-down" : "bx bx-sort-up"}
        ></i>
      )
    )
  }

  const toggleRowExpansion = rowId => {
    setExpandedRow(expandedRow === rowId ? null : rowId)
  }

  return (
    <Fragment>
      <div className={`${onClick && "table-responsive"} react-table`}>
        <Table bordered hover {...getTableProps()}>
          <TableHead
            headerGroups={headerGroups}
            onHeaderClick={onHeaderClick}
            generateSortingIndicator={generateSortingIndicator}
            widthControl={widthControl}
            tableHeader={tableHeader}
            setExpandedRow={setExpandedRow}
          />
          {page.length > 0 && footeraddition && (
            <TableFooter isMobile={isMobile} footerGroups={footerGroups} />
          )}
          <TableBody
            page={
              page.map((data, index) => {
                data.id = String(index);
                data.index = index;
                data.original.index = index;
                return data;
              })}
            getTableBodyProps={getTableBodyProps}
            tableheadShow={tableheadShow}
            expandedRow={expandedRow}
            headerGroups={headerGroups}
            prepareRow={prepareRow}
            toggleRowExpansion={!dateMatch ? toggleRowExpansion: null}
            columns={columns}
            data={data}
            activeworkfromhome={activeworkfromhome}
            isMobile={isMobile}
            dateMatch={dateMatch}
            totalHoursLoader={totalHoursLoader}
          />
        </Table>
      </div>
    </Fragment>
  )
}

export default TableContainer
